import request from '../utils/request'

export default {
  /**
   * 功能：获取人工计划分类以及分类下的全部启用彩种。
   * 参数：无。
   */
  getManualPlanCatalog() {
    return request({
      url: '/manualPlan?ac=catalog',
      method: 'get'
    })
  },

  /**
   * 功能：获取指定人工计划彩种的当前开奖快照，过期刷新由后端处理。
   * 参数：lotteryId 人工计划彩种ID。
   */
  getManualPlanDraw(lotteryId) {
    return request({
      url: '/manualPlan?ac=draw',
      method: 'get',
      params: { lotteryId }
    })
  },

  /**
   * 功能：获取人工计划筛选区配置，并按玩法联动码数和公式数。
   * 参数：params 包含 lotteryId、可选 playCode 和 subPlayCode。
   */
  getManualPlanFilterConfig(params) {
    return request({
      url: '/manualPlan?ac=filterConfig',
      method: 'get',
      params,
      timeout: 35000
    })
  },

  /**
   * 功能：按当前筛选条件获取人工计划列表。
   * 参数：params 包含彩票ID以及源站玩法、中奖、码数、期数和公式数参数。
   */
  getManualPlanList(params) {
    return request({
      url: '/manualPlan?ac=planList',
      method: 'get',
      params,
      timeout: 35000
    })
  },

  /**
   * 功能：获取指定人工计划在当前玩法、码数和期数下的详情。
   * 参数：params 包含彩票ID、计划ID、计划名称以及源站筛选参数。
   */
  getManualPlanDetail(params) {
    return request({
      url: '/manualPlan?ac=planDetail',
      method: 'get',
      params,
      timeout: 35000
    })
  },

  /**
   * 功能：获取登录用户在指定彩种下收藏的全部人工计划。
   * 参数：lotteryId 人工计划彩种ID。
   */
  getManualPlanFavorites(lotteryId) {
    return request({
      url: '/manualPlan?ac=favoriteList',
      method: 'get',
      params: { lotteryId }
    })
  },

  /**
   * 功能：按明确状态收藏或取消收藏一项人工计划。
   * 参数：data 包含彩种、计划、筛选快照及status收藏状态。
   */
  setManualPlanFavorite(data) {
    return request({
      url: '/manualPlan?ac=favoriteSet',
      method: 'post',
      data
    })
  }
}
